import React from 'react';
import { checkJsonProp, trb } from "../../Utilities";

const SelectAdapter = ({ input, meta, props, ...rest }) => {

  const selectOptions = (array) => {
    let options = [];

    if (!array) {
      return null;
    }

    Object.entries(array).map(([value, text]) =>
      options.push({ "optionsValue": text, "optionsText": text })
    );

    return options;
  };

  return (
    <div className="input has-value input-big">
      <select
        {...input}
        {...rest}
        className={meta.error && meta.touched ? "is-invalid " + rest.className : rest.className}
      >
        {!props.data.noEmpty &&
        <option />
        }
        {checkJsonProp(props, "data.options") ?
          props.data.array ?
            selectOptions(props.data.options).map((option, index) => {
              return (
                <option
                  key={index}
                  value={option.optionsValue}
                >{props.data.translateGroup ? trb(props.data.translateGroup + option.optionsText) : props.data.translate ? trb(option.optionsText) : option.optionsText}</option>
              );
            }) : props.data.options.map((option, index) =>
              <option
                key={index}
                value={option[checkJsonProp(props, "data.optionsValue")]}
                disabled={checkJsonProp(option, "disabled")}
              >{props.data.translateGroup ? trb(props.data.translateGroup + option[props.data.optionsText]) : props.data.translate ? trb(option[props.data.optionsText]) : option[props.data.optionsText]}</option>
            ) : null}
      </select>
      {meta.touched && meta.error}
    </div>
  );
}

export default SelectAdapter;
